import React, {useEffect} from "react";
import "./App.css";
import RouterComponent from "./RouterComponent";
import { isTokenExpired } from "./libs/verifyJwtTokenValidity";
import { useNavigate } from "react-router-dom";
function App() {
  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem('accessToken')) {
      const token = localStorage.getItem('accessToken');
      console.log("::::::::", isTokenExpired(token))
      if (isTokenExpired(token)) {
        localStorage.removeItem('accessToken');
        navigate('/');
      } 
      // else {
      //   setUser(JSON.parse(localStorage.getItem('user')));
      // }
    } else {
      navigate('/');
    }
  }, []);
  
  return (
    <div className="App">
      <RouterComponent />
    </div>
  );
}

export default App;
